import HttpRequest from '@/libs/axios';
import config from '@/config';
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
const fileServerUrl = process.env.NODE_ENV === 'development' ? config.fileServerUrl.dev : config.fileServerUrl.pro;

const axios = new HttpRequest(baseUrl, fileServerUrl);
export default axios;



// WEBPACK FOOTER //
// ./src/libs/api.request.js